export class LaborGuideItem {

    constructor(
        public AddonId: number,
        public LaborGuideId: number,
        public Title: string,
        public Description: string,
        public ParentId: number,
        public Type: string,
        public ProdemandPath: string,
        public AllDataPath: string,
        public IsDelete: boolean,
        public LaborHour: number,
        public IsVerified: number,
        public ParentName: string,

    ) { }
}
